export const SETUP_V2_STORAGE_KEY = 'cf.setup.v2-enabled'

export function isSetupV2Preferred(): boolean {
  return localStorage.getItem(SETUP_V2_STORAGE_KEY) !== 'false'
}
